import type { RouteEntry } from '../types';

// ═══════════════════════════════════════════════════════════════════════════
// PUBLIC ROUTES (no ProtectedRoute wrapper)
// ═══════════════════════════════════════════════════════════════════════════
export const PUBLIC_ROUTES: RouteEntry[] = [
  {
    path: '/',
    component: 'LandingPage',
    label: '',
    allowedRoles: [], // public
    hideFromNav: true,
  },
  {
    path: 'login',
    component: 'LoginPage',
    label: '',
    allowedRoles: [], // public
    hideFromNav: true,
  },
];
